import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "dataForm",
  style: {"width":"98%"}
}
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "dialog-footer mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_AccountPreview = _resolveComponent("AccountPreview")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MaterialTable = _resolveComponent("MaterialTable")!
  const _component_FromField = _resolveComponent("FromField")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.purchaseType === 1 && _ctx.from !== 'local')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "form-title mb-10" }, [
            _createElementVNode("span", { class: "label blue" }, "购"),
            _createElementVNode("span", { class: "left" }, "采购信息")
          ], -1)),
          (_ctx.detail.account)
            ? (_openBlock(), _createBlock(_component_AccountPreview, {
                key: 0,
                account: _ctx.detail.account
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "是否含税：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.containsRate ? '是' : '否'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "税率：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.rate || 0) + "%", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "发票类型：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.invoiceTypeName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["account"]))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-title mb-10 mt-10" }, [
            _createElementVNode("span", { class: "label yellow" }, "物"),
            _createElementVNode("span", { class: "left" }, "物料信息")
          ], -1)),
          _createVNode(_component_MaterialTable, {
            materialData: _ctx.detail.details,
            storageVisible: true
          }, {
            after: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "command",
                label: "操作",
                fixed: "right",
                "min-width": "130"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleAddComand(row))
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("添加", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleAddComand(row, true)),
                    style: {"margin-left":"10px"},
                    disabled: row.virtualStorage === 1
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("虚拟入库", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "disabled"])), [
                    [_directive_permission, { pkey: `PURCHASE_VIRTUAL_RUKU` }]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["materialData"])
        ], 64))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromFieldData, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_form, {
        class: "mb-20 mt-20",
        ref_for: true,
        ref: el => _ctx.dataForm[index] = el,
        model: item,
        "label-position": "top",
        "label-width": "100px",
        key: index
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: _normalizeClass(["label", item.labelClass])
            }, _toDisplayString(item.labelName), 3),
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1),
            (item.type === 2 && !item.formList.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAddComand && _ctx.handleAddComand(...args))),
                  class: "add-icon add-title cursor"
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "iconfont icon-tubiao-25" }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formList, (j, k) => {
            return (_openBlock(), _createElementBlock("div", {
              key: k,
              class: "border-container"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(j.list, (fields, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  (_ctx.handleVisible(fields, j.list))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        class: _normalizeClass([fields.componentType, { fullWidth: fields.config.width }]),
                        rules: fields.rules,
                        prop: 'formList.' + k + '.list.' + i + '.value',
                        label: fields.fieldName,
                        error: fields.rules[0].message
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_FromField, {
                            fields: fields,
                            onFormChange: ($event: any) => (_ctx.handleChange(fields, index, j.list)),
                            id: _ctx.id
                          }, null, 8, ["fields", "onFormChange", "id"])
                        ]),
                        _: 2
                      }, 1032, ["class", "rules", "prop", "label", "error"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("i", {
                onClick: ($event: any) => (_ctx.handleDelete(item.formList, k)),
                class: "delete-icon"
              }, null, 8, _hoisted_4)
            ]))
          }), 128))
        ]),
        _: 2
      }, 1032, ["model"]))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.submitLoading,
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}